const machine_txt = {
    type: "VA-958-3D/4D/5D",
    name: "Direct drive overlock sewing machine",
    description: [
        "The overlock sewing machine 958 uses a three to five line chain stitch to wrap the edges of the sewing material,preventing pilling and enhancing durability",
        "Applications include seam edging for knitted garments such as underwear,sportswear,and shoes,as well as processing materials such as non-woven fabrics.",
        "The equipment supports sewing from thin to medium thick materials,with low sewing tension and stable stitching even during high-speed operation."
    ],
    //绝对路径
    machine_img:[
        "/assets/machine/5/machine_img/1.jpg",
    ],
    machine_other_img:[
        "/assets/machine/5/machine_other/1.png",
    ]
}
export default {machine_txt}